import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { injectable, inject } from 'inversify';
import { PRODUCTLINETYPE } from './ProductLineService.type';
import _ from 'lodash';
let ProductLineService = class ProductLineService {
    constructor(operationCenterApi, i18n) {
        this.operationCenterApi = operationCenterApi;
        this.i18n = i18n;
        this.productLine = [];
    }
    get productLineType() {
        return Object.fromEntries(Object.entries(PRODUCTLINETYPE).map(([key, value]) => [key, value]));
    }
    getCurrentProductLine(product_id) {
        const item = this.productLine.find((item) => item.product_line_key === product_id);
        if (!item && this.productLine.length > 0) {
            return this.productLine[0];
        }
        return item;
    }
    getProductLine(product_line_type) {
        return this.operationCenterApi.getProductLine(product_line_type).then((res) => {
            const productLine = _.map(res, item => {
                if (item.product_line_key === 'backoffice') {
                    return {
                        ...item,
                        product_name: this.i18n.t('backoffice.common.generalLine'),
                    };
                }
                return item;
            });
            this.productLine = productLine;
            return productLine;
        });
    }
    deleteProductLine(id) {
        return this.operationCenterApi.deleteProductLine(id);
    }
    postProductLine(params) {
        return this.operationCenterApi.postProductLine(params);
    }
    deleteConfirm(vm) {
        return vm.$swal({
            title: this.i18n.t('backoffice.alert.deleteTitle'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: this.i18n.t('backoffice.common.yes'),
            cancelButtonText: this.i18n.t('backoffice.common.no'),
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-outline-danger ml-1',
            },
            buttonsStyling: false,
        }).then((result) => result.value);
    }
};
ProductLineService = __decorate([
    injectable(),
    __param(0, inject(Symbols.OperationCenterApi)),
    __param(1, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object, Object])
], ProductLineService);
export { ProductLineService };
